import { setRouter } from "@features/authentication";
import { setQueryClient } from "@features/authentication/model/invalidate-queries";
import { BigNumber } from "bignumber.js";

import { makeQueryClient } from "@shared/api/query-client";

import { makeRouter } from "../navigation";
import { initializeNetwork } from "./initialize-network";
import { initializeNonce } from "./initialize-nonce";
import { initializeSession } from "./initialize-session";
import { renderApp } from "./render-app";
import { renderCrashApp } from "./render-crash-app";
BigNumber.config({ EXPONENTIAL_AT: [-1e9, 1e9] });
export const initializeApp = async () => {
  try {
    const queryClient = makeQueryClient();
    setQueryClient({ invalidate: async () => queryClient.clear() });
    const router = makeRouter(queryClient);
    await initializeNetwork();
    setRouter(router);
    initializeSession();
    const nonce = initializeNonce();
    await renderApp({ nonce, queryClient, router });
  } catch (e: unknown) {
    await renderCrashApp({ error: e });
  }
};
